import usePartyStore from "../../../stores/party.js";
import Party from "../../../modules/party/index.js";

function Standings() {
	const party = usePartyStore.getState().party!;
	const results = Party.aggregateResults();

	return (
		<div style={{ display: "flex", flexDirection: "column", gap: "var(--space-2)" }}>
			{results.map((row: Record<string, unknown>, i: number) => {
				const player = party.players[row.playerId as string];
				const position = row.position as number;
				const isMe = row.playerId === party.activePlayerId;

				return (
					<div
						key={i}
						style={{
							display: "flex",
							alignItems: "center",
							gap: "var(--space-3)",
							padding: "var(--space-3) var(--space-4)",
							borderRadius: "var(--radius-md)",
							background: "var(--bg-surface)",
							border: "1px solid var(--border)",
						}}
					>
						{/* Position */}
						<span style={{
							width: 24,
							textAlign: "center",
							fontWeight: 800,
							fontSize: "0.95rem",
							color: position === 1 ? "var(--reward)" : "var(--text-muted)",
							flexShrink: 0,
						}}>
							{position}
						</span>

						{/* Color dot */}
						<div style={{
							width: 10,
							height: 10,
							borderRadius: "50%",
							background: player.color,
							flexShrink: 0,
							boxShadow: `0 0 6px ${player.color}88`,
						}} />

						{/* Name */}
						<span style={{
							flex: 1,
							fontWeight: 600,
							fontSize: "0.95rem",
							color: player.color,
						}}>
							{player.name}
						</span>

						{/* Controller icon for active player */}
						{isMe && (
							<span style={{ fontSize: "0.75rem", color: "var(--text-muted)" }}>you</span>
						)}

						{/* Score */}
						<span style={{
							fontWeight: 700,
							fontSize: "0.9rem",
							color: "var(--reward)",
							background: "var(--reward-muted)",
							border: "1px solid rgba(255,230,109,0.2)",
							borderRadius: "var(--radius-pill)",
							padding: "2px 10px",
						}}>
							{row.score as number}
						</span>
					</div>
				);
			})}
		</div>
	);
}

export default Standings;
